import { render, staticRenderFns } from "./study-psc.vue?vue&type=template&id=0de296fc&"
import script from "./study-psc.vue?vue&type=script&lang=js&"
export * from "./study-psc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports